// src/context/DeviceContext.jsx

import React, { createContext, useContext, useState, useEffect } from 'react';

const DeviceContext = createContext();

export const DeviceProvider = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTWA, setIsTWA] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(window.innerWidth <= 1200);
      
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
      const isTwaReferrer = document.referrer.includes('android-app://');
      const isTwaUA = /Version\/.*Chrome\/.*Mobile/i.test(navigator.userAgent) && !/Mobile\/\w+/.test(navigator.userAgent);
      
      setIsTWA(isStandalone || isTwaReferrer || isTwaUA);
    };

    checkDevice();

    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  return (
    <DeviceContext.Provider value={{ isMobile, isTWA }}>
      {children}
    </DeviceContext.Provider>
  );
};

export const useDevice = () => {
  const context = useContext(DeviceContext);
  if (!context) {
    throw new Error('useDevice must be used within DeviceProvider');
  }
  return context;
};
